import nav from './nav';
import hoteltip from './hoteltip';
import scrollRestoration from './scrollRestoration';

export default class App {
  initCore() {
    scrollRestoration.disable();
    nav.hamburger();
    hoteltip.init();
  }
}

function LoadApp() {
  const app = new App();
  app.initCore();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', LoadApp);
} else {
  LoadApp();
}
